import { AddBOUserRPCClientImpl } from "@pulse/pulse-rpcs/lib/bo-user-management/addBoUserRPCClientImpl";
import { ArchiveBOUserRPCClientImpl } from "@pulse/pulse-rpcs/lib/bo-user-management/archiveBoUserRPCClientImpl";
import { EditBOUserRPCClientImpl } from "@pulse/pulse-rpcs/lib/bo-user-management/editBoUserRPCClientImpl";
import { GetBOUserRolesRPCClientImpl } from "@pulse/pulse-rpcs/lib/bo-user-management/getBoUserRolesRPCClientImpl";
import { GetBOUsersRPCClientImpl } from "@pulse/pulse-rpcs/lib/bo-user-management/getBoUsersRPCClientImpl";
import { SendPasswordResetLinkToBOUserRPCClientImpl } from "@pulse/pulse-rpcs/lib/bo-user-management/sendPasswordResetLinkToBoUserRPCClientImpl";
import { MOCK } from "@pulse/shared-components";
import { APIClient } from "@surya-digital/tedwig";
import { MockAddBOUserRPCClientImpl } from "./MockAddBOUserRPCClientImpl";
import { MockGetBOUserRolesRPCClientImpl } from "./MockGetBOUserRolesRPCClientImpl";
import { MockEditBOUserRPCClientImpl } from "./MockEditBOUserRPCClientImpl";
import { MockGetBOUsersRPCClientImpl } from "./MockGetBOUsersRPCClientImpl";
import { MockSendPasswordResetLinkToBOUserRPCClientImpl } from "./MockSendPasswordResetLinkToBOUserRPCClientImpl";
import { MockArchiveBOUserRPCClientImpl } from "./MockArchiveBOUserRPCClientImpl";
import { GetBOUsersRPC } from "@pulse/pulse-rpcs/lib/bo-user-management/getBoUsersRPC";
import { AddBOUserRPC } from "@pulse/pulse-rpcs/lib/bo-user-management/addBoUserRPC";
import { GetBOUserRolesRPC } from "@pulse/pulse-rpcs/lib/bo-user-management/getBoUserRolesRPC";
import { EditBOUserRPC } from "@pulse/pulse-rpcs/lib/bo-user-management/editBoUserRPC";
import { SendPasswordResetLinkToBOUserRPC } from "@pulse/pulse-rpcs/lib/bo-user-management/sendPasswordResetLinkToBoUserRPC";
import { ArchiveBOUserRPC } from "@pulse/pulse-rpcs/lib/bo-user-management/archiveBoUserRPC";

export const useGetBOUsersRPCClient = (apiClient: APIClient): GetBOUsersRPC => {
  if (MOCK.boManagement) {
    return new MockGetBOUsersRPCClientImpl();
  } else {
    return new GetBOUsersRPCClientImpl(apiClient);
  }
};

export const useAddBOUserRPCClientImpl = (
  apiClient: APIClient,
): AddBOUserRPC => {
  if (MOCK.boManagement) {
    return new MockAddBOUserRPCClientImpl();
  } else {
    return new AddBOUserRPCClientImpl(apiClient);
  }
};

export const useGetBOUserRolesRPCClientImpl = (
  apiClient: APIClient,
): GetBOUserRolesRPC => {
  if (MOCK.boManagement) {
    return new MockGetBOUserRolesRPCClientImpl();
  } else {
    return new GetBOUserRolesRPCClientImpl(apiClient);
  }
};

export const useEditBOUserRPCClientImpl = (
  apiClient: APIClient,
): EditBOUserRPC => {
  if (MOCK.boManagement) {
    return new MockEditBOUserRPCClientImpl();
  } else {
    return new EditBOUserRPCClientImpl(apiClient);
  }
};

export const useSendPasswordResetLinkToBOUserRPCClientImpl = (
  apiClient: APIClient,
): SendPasswordResetLinkToBOUserRPC => {
  if (MOCK.boManagement) {
    return new MockSendPasswordResetLinkToBOUserRPCClientImpl();
  } else {
    return new SendPasswordResetLinkToBOUserRPCClientImpl(apiClient);
  }
};
export const useArchiveBOUserRPCClientImpl = (
  apiClient: APIClient,
): ArchiveBOUserRPC => {
  if (MOCK.boManagement) {
    return new MockArchiveBOUserRPCClientImpl();
  } else {
    return new ArchiveBOUserRPCClientImpl(apiClient);
  }
};
